module.exports = __webpack_public_path__ + "img/nft-icon.5e55fde9.svg";